import React, { Fragment, useEffect, useRef, useState } from 'react';

const CommonSidePortal = ({
  ViewSection,
  OpenSection,
  KWY = '1',
  portalId,
  activeId,
  setActiveId,
  Padding,
  Top,
  Right,
  Left,
  MinWidth,
  Width,
  HandleEllipseClick,

  /** NEW PROP */
  preferredSide = "auto", // "left", "right", "auto"
}) => {
  const dropdownRef = useRef(null);
  const toggleRef = useRef(null);

  const [positionStyle, setPositionStyle] = useState(null);
  const isOpen = activeId === portalId;

  /** Outside Click Close */
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        toggleRef.current &&
        !toggleRef.current.contains(event.target)
      ) {
        setActiveId(null);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setActiveId]);

  /** Decide LEFT/RIGHT based on prop OR auto */
  useEffect(() => {
    if (isOpen && toggleRef.current && dropdownRef.current) {
      const toggleRect = toggleRef.current.getBoundingClientRect();
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      let openLeft = false;

      if (preferredSide === "left") openLeft = true;
      else if (preferredSide === "right") openLeft = false;
      else {
        // auto
        openLeft = toggleRect.right + dropdownRect.width > viewportWidth;
      }

      setPositionStyle(
        openLeft
          ? { right: '100%', left: 'auto' } 
          : { left: '100%', right: 'auto' }
      );
    } else {
      setPositionStyle(null);
    }
  }, [isOpen, preferredSide]);


  return (
    <Fragment>
      <div className="crm_p_relative" key={KWY} style={{ position: 'relative' }}>
        
        <div
          onClick={(e) => {
            e.stopPropagation();
            HandleEllipseClick && HandleEllipseClick();
            setActiveId(isOpen ? null : portalId);
          }}
          className="crm_cursor_pointer"
          style={{ position: 'relative' }}
          ref={toggleRef}
        >
          {ViewSection}
        </div>

        {isOpen && (
          <div
            ref={dropdownRef}
            className="cart_list"
            style={{
              top: 'auto',
              zIndex: 9999999999,
              padding: Padding,
              position: 'absolute',
              ...positionStyle,
              ...(MinWidth && { minWidth: MinWidth }),
              ...(Width && { width: Width }),
              ...(Top && { top: Top }),
              ...(Left && { left: Left }),
              ...(Right && { right: Right }),
              visibility: positionStyle ? 'visible' : 'hidden',
            }}
          >
            <div>{OpenSection}</div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default CommonSidePortal;
